import React from "react";
import classNames from "classnames";

import Avatar from "@components/Avatar";
import UserBadges from "@components/UserBadges";

import { toDollar } from "@helpers/price";
import useAnimatedAmounts from "@pages/Livestream/hooks/useAnimatedAmounts";

import { roles } from "@const/livestreams";

import styles from "../index.module.scss";

const NewTipMessage = ({
  author,
  text,
  type,
  recipient,
  isSupporter,
  isPromoter,
  isMostProfitableSupporter,
  isMostProfitablePromoter,
  ...rest
}) => {
  const { amountsList } = useAnimatedAmounts();
  const amountItem = amountsList.find(({ amount, testAmount }) => {
    return amount === +text || testAmount === +text;
  });
  if (!amountItem) return;
  const { Icon } = amountItem;
  const isModerator = rest.streamParticipant.role === roles.moderator;

  return (
    <div className={classNames(styles.messageContainer)}>
      <div className="position-relative h-fit-content">
        <Avatar
          avatar={author?.avatar}
          className={styles.avatarContainer}
          type={isModerator ? "moderator" : type}
        />
        {recipient && (
          <Avatar
            avatar={recipient.avatar}
            className={styles.recipientAvatar}
          />
        )}
      </div>
      <div className="w-100">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="d-flex">
            <span
              className={classNames(
                "text-body-2 text-semibold",
                styles.chatUsername,
              )}
            >
              {author?.username}
            </span>
            <UserBadges
              isPaid
              isPromoter={isPromoter}
              isSupporter={isSupporter}
              isIdentityVerified={author?.isIdentityVerified}
              isMostProfitablePromoter={isMostProfitablePromoter}
              isMostProfitableSupporter={isMostProfitableSupporter}
            />
          </div>
        </div>
        <div className="fit-content d-flex align-items-center">
          <Icon />
          <span className="text-body-2 text-medium message-description ms-2">
            ${toDollar(+text)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default NewTipMessage;
